import { LOCALE_TARGETS } from '../const/locale-targets.const';
import { IAppLocale } from '../models/locale.model';

/**
 * Cross-domain path+query preservation. Each locale lives on its own domain
 * (domain-per-language), so language switching is a navigation to a sibling
 * host with the same path+query. A leading "/" is always enforced on path.
 */
export function buildLocaleHref(target: IAppLocale, pathWithSearch: string, currentLocale: IAppLocale): string {
    if (target === currentLocale) {
        return pathWithSearch || '/';
    }
    const normalisedPath: string = pathWithSearch.startsWith('/') ? pathWithSearch : `/${pathWithSearch}`;
    return `${LOCALE_TARGETS[target].origin}${normalisedPath}`;
}
